import { render, staticRenderFns } from "./AuthLeftInfo.vue?vue&type=template&id=0c27174f&scoped=true"
import script from "./AuthLeftInfo.vue?vue&type=script&lang=js"
export * from "./AuthLeftInfo.vue?vue&type=script&lang=js"
import style0 from "./AuthLeftInfo.vue?vue&type=style&index=0&id=0c27174f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27174f",
  null
  
)

export default component.exports